<template>
  <div id="mainContent" class="min-h-0 flex flex-col h-full">
    <div class="flex-1 flex flex-col space-y-3 p-3 min-h-0">
      <!-- Help Card -->
      <div class="bg-background-card rounded-lg shadow-card overflow-hidden">
        <div class="bg-primary/10 px-4 py-3 border-b border-border flex items-center justify-between">
          <h1 class="text-xl font-bold text-primary flex items-center">
            <i class="fa-solid fa-question-circle mr-2"></i>
            Help & Support
          </h1>
          <div class="flex items-center space-x-1">
            <button class="bg-accent text-text-inverse rounded-full px-3 py-1 text-xs font-medium hover:bg-accent-dark transition-colors">
              <i class="fa-solid fa-envelope mr-1"></i>
              Contact Support
            </button>
          </div>
        </div>
        <div class="p-4">
          <div class="text-center py-12">
            <i class="fa-solid fa-question-circle text-4xl text-text-muted mb-4"></i>
            <h3 class="text-lg font-semibold text-text mb-2">Help & Support</h3>
            <p class="text-text-light">Find answers to common questions and get support for ADAM Cloud.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
definePage({
  meta: {
    title: 'Help & Support',
    requiresProject: false,
  },
});
</script>